import "./TypeAnimation.css"
import { useState, useEffect } from "react";

export default function TypeAnimation({ typeTexts }) {
    const [text, setText] = useState("");
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        if (index === typeTexts.length) {
            setIndex(0);
            return;
        }
        if (
            subIndex === typeTexts[index].length + 1 &&
            !deleting
        ) {
            setTimeout(() => setDeleting(true), 1000);
            return;
        }
        if (subIndex === 0 && deleting) {
            setDeleting(false);
            setIndex((prev) => (prev + 1) % typeTexts.length);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) =>
                deleting ? prev - 1 : prev + 1
            );
            setText(typeTexts[index].substring(0, subIndex));
        }, deleting ? 25 : 60);

        return () => clearTimeout(timeout);
    }, [subIndex, index, deleting]);

    return (
        <div className="type-animation">{text}<span className="cursor">|</span></div>
    );
}